import PathologyChart from "../../../components/PathologyChart/PathologyChart";
import DiseaseMap from "../DiseaseMap/DiseaseMap";


export default function InteractiveMapAndChart({padding}) {
    const _padding = padding || "unset"
    return <section style={{background: "#00516320", padding: _padding}}>
        <DiseaseMap />
        <PathologyChart />
    </section>
}